const filterFields = (fields, mode) => {
  return fields.filter(field => !field.onlyOn || field.onlyOn === mode);
};

export default {
  buildSchema: state => (namespace, schema, page, mode) => {
    const unfilteredSchema = state.admin[namespace][schema][page];
    const allSchema = state.admin[namespace][schema].all;
    const filteredSchema = {};
    Object.keys(unfilteredSchema).forEach(key => filteredSchema[key] = unfilteredSchema[key]);
    filteredSchema.fields = filterFields(unfilteredSchema.fields, mode);
    if (unfilteredSchema.includeAll && allSchema) {
      filteredSchema.fields.push(...filterFields(allSchema.fields, mode));
    }
    return filteredSchema;
  },

  inAdminArea: state => state.route.name.startsWith('admin'),
};
